<template>
  <section>
    <section class="relative">
      <div class="bg-blue-700 text-white pb-3">
        <!-- mobile -->
        <div class="gridClass just-mobile">
          <div class="">
            <div class="grid grid-cols-2">
              <div
                class="flex flex-col py-3 items-center text-center border-e border-b"
              >
                <span class="text-xl">{{ navaInfo.customers }}</span>
                <span class="opacity-50">مشتری</span>
              </div>
              <div
                class="flex flex-col py-3 items-center text-center border-s border-b"
              >
                <span class="text-xl">{{ navaInfo.costReduction }}</span>
                <span class="opacity-50">کم شدن هزینه</span>
              </div>
              <div
                class="flex flex-col py-3 items-center text-center border-e border-t"
              >
                <span class="text-xl">{{ navaInfo.satisfaction }}</span>
                <span class="opacity-50">رضایت مشتری</span>
              </div>
              <div
                class="flex flex-col py-3 items-center text-center border-s border-t"
              >
                <span class="text-xl">{{ navaInfo.province }}</span>
                <span class="opacity-50">استان تحت پوشش</span>
              </div>
            </div>
            <div class="flex flex-col py-3 mt-2 items-center text-center">
              <span class="text-xl">{{ navaInfo.install }}</span>
              <span class="opacity-50">نصب اپلیکیشن نواتل</span>
            </div>
          </div>
        </div>
        <!-- mobile -->

        <!-- desktop -->
        <div class="gridClass just-desktop">
          <div class="">
            <div class="flex justify-between">
              <div class="flex flex-col pt-10 pb-3 items-center text-center">
                <div class="text-3xl w-full mb-2 text-white">
                  {{ navaInfo.customers }}
                </div>
                <span class="text-xl w-full text-blue-350">مشتری</span>
              </div>
              <div class="flex flex-col pt-10 pb-3 items-center text-center">
                <div class="text-3xl w-full mb-2 text-white">
                  {{ navaInfo.install }}
                </div>
                <span class="text-xl w-full text-blue-350"
                  >نصب اپلیکیشن نواتل</span
                >
              </div>
              <div class="flex flex-col pt-10 pb-3 items-center text-center">
                <div class="text-3xl w-full mb-2 text-white">
                  {{ navaInfo.satisfaction }}
                </div>
                <span class="text-xl w-full text-blue-350">رضایت مشتری</span>
              </div>
              <div class="flex flex-col pt-10 pb-3 items-center text-center">
                <div class="text-3xl w-full mb-2 text-white">
                  {{ navaInfo.costReduction }}
                </div>
                <span class="text-xl w-full text-blue-350">کم شدن هزینه</span>
              </div>
              <div class="flex flex-col pt-10 pb-3 items-center text-center">
                <div class="text-3xl w-full mb-2 text-white">
                  {{ navaInfo.province }}
                </div>
                <span class="text-xl w-full text-blue-350">استان تحت پوشش</span>
              </div>
            </div>
          </div>
        </div>
        <!-- desktop -->
      </div>

      <!-- mobile form -->
      <!-- <div class="just-mobile gridClass" id="counseling_form">
        <div
          class="-top-20 py-6 w-full bg-yellow-500 px-4 laptop:px-10 rounded-3xl"
        >
          <div
            class="pb-6 text-base laptop:text-3xl font-bold text-blue-700 text-center"
          >
            دریافت مشاوره رایگان
          </div>
            <Form
              class="w-full"
              :validation-schema="schema"
              :initial-values="initialValues"
              @submit="handleSubmit"
            >
              <BaseInput
                color="yellow"
                name="name"
                placeholder="نام و نام خانوادگی"
              />
              <BaseInput
                color="yellow"
                name="number"
                placeholder="شماره موبایل"
              />
              <div class="flex justify-end">
                <button
                  type="submit"
                  class="bg-transparent"
                  id="request_counseling"
                >
                  <div class="flex h-10 shadow-md rounded-lg">
                    <div
                      href="#"
                      class="w-[110px] flex justify-center items-center font-bold rounded-s-lg bg-white text-blue-500"
                    >
                      ارسال
                    </div>
                    <div
                      href="#"
                      class="w-[65px] flex justify-center items-center font-bold rounded-e-lg bg-yellow-500"
                      aria-current="page"
                    >
                      <div class="w-10">
                        <BaseIcon name="arrow-left" color="text-white" />
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </Form>
        </div>
      </div> -->

      <!-- desktop form -->
      <!-- <div class="just-desktop bg-blue-700">
        <div class="px-16 py-10">
          <div class="flex bg-yellow-500 rounded-lg">
            <div class="w-full laptop:w-[47%] text-black px-10 pb-10">
              <div class="font-bold">
                <div class="py-6 text-justify">
                  لطفا جهت دریافت مشاوره رایگان و ثبت سفارش، فرم زیر را تکمیل
                  نمایید تا همکاران ما در اسرع وقت با شما تماس بگیرند.
                </div>
                <Form
                  ref="mainModalForm"
                  class="w-full"
                  :validation-schema="schema"
                  :initial-values="initialValues"
                  @submit="handleSubmit"
                >
                  <BaseInput
                    hasBorder
                    size="full"
                    name="name"
                    placeholder="نام و نام خانوادگی"
                  />
                  <BaseInput
                    hasBorder
                    size="full"
                    name="number"
                    placeholder="شماره تماس"
                  />
                </Form>
                <div class="flex justify-end">
                <button
                  type="submit"
                  class="bg-transparent"
                  id="request_counseling"
                >
                  <div class="flex h-10 shadow-md rounded-lg">
                    <div
                      href="#"
                      class="w-[110px] flex justify-center items-center font-bold rounded-s-lg bg-white text-blue-700"
                    >
                      ارسال
                    </div>
                    <div
                      href="#"
                      class="w-[65px] flex justify-center items-center font-bold rounded-e-lg bg-yellow-500"
                      aria-current="page"
                    >
                      <div class="w-10">
                        <BaseIcon name="arrow-left" color="text-white" />
                      </div>
                    </div>
                  </div>
                </button>
              </div>
              </div>
            </div>
            <div
              class="just-desktop w-[53%] bg-yellow-500 rounded-lg p-8"
            >
              <div
                class="w-full h-full bg-[#EAEEF6] pt-6 text-center flex flex-col justify-between text-white rounded-lg"
              >
                <div
                  class="flex-grow pb-24 font-bold flex flex-col justify-between"
                >
                  <div class="mt-2 text-2xl text-blue-700">
                    دریافت مشاوره رایگان
                  </div>
                </div>
                <div
                  class="bg-blue-800 h-3/5 pb-6 flex flex-col justify-center relative rounded-b-lg"
                >
                  <div
                    class="absolute w-full -top-20 h-40 flex justify-center items-center"
                  >
                    <NuxtImg
                      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                      width="1000"
                      height="1000"
                      class="rounded-full w-[150px]"
                      src="/img/img-form.webp"
                      format="webp"
                      alt="contact navatel"
                    />
                  </div>
                  <div class="pt-20 px-6 text-xl text-center">
                    نواتل ابزاری قدرتمند برای ساده کردن کسب‌و‌کار شما
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </section>
  </section>
</template>

<script setup>
import { object, string } from "yup";
import { Form } from "vee-validate";
const { validateFaChar, validateMobile } = useInputHelpers();

defineProps({
  // data: Object,
});

const navaInfo = {
  customers: "8000+",
  install: "100/000+",
  satisfaction: "99%+",
  costReduction: "90%+",
  province: "31",
};

const { post, loading } = useSendMail();

const successModalButton = ref();

const isSuccessModalShowState = useState("isSuccessModalShowState");

const initialValues = {
  name: "",
  number: "",
};
const schema = object({
  name: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
});
const handleSubmit = async (form, { resetForm }) => {
  if (!loading.value) {
    const { data, error } = await post({
      body: { model: form },
    });
    if (!error.value && data.value === "ok") {
      resetForm();
      isSuccessModalShowState.value = true;
    }
  }
};
</script>

<style scoped>
.card-bottom > h2 {
  color: #ffffff;
}

.numbers {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(0, 1fr);
}

.v-btn-toggle {
  background: unset !important;
}

.icon-send {
  background-color: #fedd5b !important;
  color: #ffffff !important;
  border: none !important;
  font-weight: bold;
  width: 65px !important;
  border-radius: 12px 0 0 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send {
  font-weight: bold;
  color: #ffffff !important;
  font-size: 26px;
}

.wrapper {
  display: none;
  grid-template-columns: repeat(2, 1fr);
  color: #ffffff;
  grid-auto-rows: minmax(100px, auto);
}
@media (min-width: 375px) {
}
@media (min-width: 425px) {
}
@media (min-width: 768px) {
  .form-moshaver {
    margin: 0 30px;
  }
}
@media (min-width: 1024px) {
}
@media (min-width: 1280px) {
}
@media (min-width: 1440px) {
}
@media (min-width: 2560px) {
}
</style>
